import { View } from '@shared/components/View';
import { MBButton, MBButtonProps } from './MBButton';

interface Props extends MBButtonProps {
  noPadding?: boolean;
}
/*
    A button component that can be used in nav bars and headers.
    This ex is used for the modal action buttons. Small size and
    has some horizontal padding.
*/
export function MBHeaderButton({ noPadding, testID, ...props }: Props) {
  return (
    <View center paddingHorizontal={noPadding ? undefined : 1}>
      <MBButton size="small" testID={testID} {...props} />
    </View>
  );
}
